import {
  FormItem,
  GroupedResidentsMultiSelect,
  GroupedUsersMultiSelect,
  RangePicker
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Alert } from 'antd'
import { getNominative } from 'common/utils'
import { NAMESPACE } from 'locale'
import { reportingTranslations } from 'locale/reporting'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import useResidentsList from 'screens/Rostering/hooks/useResidentsList'
import useUsersList from 'screens/Rostering/hooks/useUsersList'
import styled from 'styled-components'

type Props = {
  preferredPeopleNominative: string
}

export const RosteringForm: FC<Props> = ({ preferredPeopleNominative }) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  const residentsNominative = getNominative(
    preferredPeopleNominative,
    'Residents'
  )

  const { residents } = useResidentsList({})

  const { users } = useUsersList({})

  return (
    <>
      <FormItem
        label={t(reportingTranslations.ROTA_EVENTS_CREATED)}
        name="dateRange"
        extra={t(reportingTranslations.ROTA_SELECT_DATES)}
        rules={[
          {
            required: true
          }
        ]}
        long
      >
        <RangePicker />
      </FormItem>
      <FormItem
        label={residentsNominative}
        name="serviceUsers"
        extra={t(reportingTranslations.ROTA_SERVICE_USERS_EXTRA, {
          variable: residentsNominative
        })}
      >
        <GroupedResidentsMultiSelect
          residents={residents}
          title={residentsNominative}
          // @ts-ignore
        />
      </FormItem>
      <FormItem noStyle dependencies={['serviceUsers']}>
        {({ getFieldValue }) => {
          const serviceUsers = getFieldValue('serviceUsers')
          return serviceUsers?.length > 0 ? (
            <StyledAlert
              description={
                <Text>
                  {t(reportingTranslations.CSV_SHIFTS_INFO, {
                    nominativePlural: getNominative(
                      preferredPeopleNominative,
                      'Service Users'
                    ),
                    nominative: getNominative(
                      preferredPeopleNominative,
                      'Service User'
                    )
                  })}
                </Text>
              }
              type="info"
              showIcon={false}
            />
          ) : null
        }}
      </FormItem>
      <FormItem
        label={t(reportingTranslations.TEAM_MEMBERS_TITLE)}
        name="teamMembers"
        extra={t(reportingTranslations.ROTA_TEAM_MEMBERS_EXTRA)}
      >
        <GroupedUsersMultiSelect
          users={users}
          title={t(reportingTranslations.TEAM_MEMBERS_TITLE)}
        />
      </FormItem>
      <FormItem
        label={t(reportingTranslations.ROTA_CREATED_BY_TITLE)}
        name="createdBy"
        extra={t(reportingTranslations.ROTA_CREATED_BY_EXTRA)}
      >
        <GroupedUsersMultiSelect
          users={users}
          title={t(reportingTranslations.TEAM_MEMBERS_TITLE)}
        />
      </FormItem>
      <FormItem
        label={t(reportingTranslations.ROTA_EDITED_BY_EXTRA)}
        name="updatedBy"
        extra={t(reportingTranslations.ROTA_EDITED_BY_TITLE)}
      >
        <GroupedUsersMultiSelect
          users={users}
          title={t(reportingTranslations.TEAM_MEMBERS_TITLE)}
        />
      </FormItem>
    </>
  )
}

const StyledAlert = styled(Alert)`
  padding: 12px;
`
